const headerWrapper = document.querySelector('.header-wrapper');
if (headerWrapper) {
  headerWrapper.classList.add('header-wrapper--transparent');
  window.addEventListener('scroll', () => {
    if (window.scrollY > 50) {
      headerWrapper.classList.remove('header-wrapper--transparent');
      headerWrapper.classList.add('header-wrapper--scrolled');
    } else {
      headerWrapper.classList.remove('header-wrapper--scrolled');
      headerWrapper.classList.add('header-wrapper--transparent');
    }
  });
}